import { createReducer, on } from "@ngrx/store";
import { BillUserError } from "../../../models/errors.model";
import { billActions } from "../bill.actions";

export interface BillExtractionState {
    errors: BillUserError|null,
    state: 'pending'|'loading'|'loaded'|'error'
}

export const initialState: BillExtractionState = {
    errors: null,
    state: 'pending'
};

export const billExtractionReducer = createReducer(
    initialState,
    on(billActions.extractBills, (state) => ({
        ...state,
        errors: null,
        state: 'loading' as const
    })),
    on(billActions.extractBillsSuccess, (state, {payload}) => ({
        ...state,
        errors: payload,
        state: 'loaded' as const
    })),
    on(billActions.extractBillsFail, (state) => ({
        ...state,
        errors: null,
        state: 'error' as const
    })),
    on(billActions.clearExtractBills, (state) => ({
        ...state,
        errors: null,
        state: 'pending' as const
    }))
)